import { render, staticRenderFns } from "./SSProfileView.vue?vue&type=template&id=70676dd8&scoped=true&"
import script from "./SSProfileView.vue?vue&type=script&lang=js&"
export * from "./SSProfileView.vue?vue&type=script&lang=js&"
import style0 from "./SSProfileView.vue?vue&type=style&index=0&id=70676dd8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70676dd8",
  null
  
)

export default component.exports